import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';

/* units?: {
  status: 'disponible' | 'reservado' | 'vendido';
  floor?: number;
  number_letter?: string;
  ambience: number;
  covered_surface: number;
  total_surface: number;
  bathrooms: number;
  currency: string;
  price: number;
  expenses?: number;
}[]; */
export const UnitHeader = ({ setHideSidebar, activeUnitIndex, activeUnit }) => (
  <div className="chat-content-header" style={{ height: 68 }}>
    <Row className="flex-between-center h-100">
      <Col xs={6} md={8} as={Flex} alignItems="center" style={{ flexGrow: 1 }}>
        <div
          className="pe-3 text-700 d-md-none contacts-list-show cursor-pointer"
          onClick={() => setHideSidebar(true)}
        >
          <FontAwesomeIcon icon="chevron-left" />
        </div>

        <div className="min-w-0">
          <h5 className="mb-0 text-truncate fs-0">
            {activeUnit?.name || `Unidad ${activeUnitIndex + 1}`}
          </h5>
        </div>
      </Col>
    </Row>
  </div>
);
UnitHeader.propTypes = {
  setHideSidebar: PropTypes.func.isRequired,
  activeUnitIndex: PropTypes.number.isRequired,
  activeUnit: PropTypes.object.isRequired
};
